// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AutomationTask from './view'

export default function AutomationTaskFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AutomationTask">
      <AutomationTask {...props}>
        {children}
      </AutomationTask>
    </Flow>
  )
}
